import React from 'react';
import styled from 'styled-components';

const AvatarWrap = styled.div<{
  size: 20 | 32 | 40 | string;
  thumbnailURL?: string | undefined;
  mobileSize?: 20 | 32 | 40 | string;
  round?: boolean;
}>`
  width: ${({ size }) => (typeof size === 'number' ? `${size}px` : size)};
  height: ${({ size }) => (typeof size === 'number' ? `${size}px` : size)};
  background: center/cover no-repeat
    ${({ thumbnailURL }) =>
    thumbnailURL ? `url('${thumbnailURL}')` : 'var(--cardBackgroundColor)'};
  border-radius: ${({ round }) => round ? '50%' : 'calc(var(--buttonBorderRadius) + 2px)'};
  border: 1px solid var(--lineColor);
  overflow: hidden;
  flex: none;

  @media (max-width: 480px) {
    width: ${({ mobileSize, size }) => 
      mobileSize 
        ? (typeof mobileSize === 'number' ? `${mobileSize}px` : mobileSize)
        : (typeof size === 'number' ? `${size}px` : size)};
    height: ${({ mobileSize, size }) => 
      mobileSize 
        ? (typeof mobileSize === 'number' ? `${mobileSize}px` : mobileSize)
        : (typeof size === 'number' ? `${size}px` : size)};
  }
`;

type AvatarProps = {
  photoURL?: string | undefined;
  size?: 20 | 32 | 40 | string;
  mobileSize?: 20 | 32 | 40 | string;
  round?: boolean;
  [propName: string]: any;
};

function Avatar({ photoURL, size = 32, mobileSize, round = false, ...props }: AvatarProps) {
  return (
    <AvatarWrap
      className="avatar"
      size={size}
      mobileSize={mobileSize}
      round={round}
      thumbnailURL={photoURL}
      {...props}
    />
  );
}

export default React.memo(Avatar);
